import { CalcModel } from '../src/components/fleet-calculator/types';
import { TrimType } from '../types';
import { getAdminUrl, getApiToken } from './helpers';

export const apiUrl = `${getAdminUrl()}/api`;

export async function fetchWithType<T>(
  request: RequestInfo,
  options?: RequestInit,
): Promise<{ data?: T; status: number }> {
  try {
    const response = await fetch(request, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });
    const contentType = response.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const status = response.status;

    const data = isJson ? await response.json() : undefined;

    if (!response.ok) throw new Error(`${status} ${response.statusText}`);

    return { data, status };
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data: ${error.message}`);
    } else {
      throw new Error(`Failed to fetch data: ${error}`);
    }
  }
}
export async function getTrim(code: string) {
  return fetchWithType<TrimType>(getAdminUrl() + '/api/car/' + code, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getApiToken()}`,
    },
  });
}

export async function getModels() {
  return await fetchWithType<CalcModel[]>(
    getAdminUrl() + '/api/calculator/models',
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getApiToken()}`,
      },
    },
  );
}
